import clsx from 'clsx';

import { useOptionSelector } from '@/App/tiles/Option/OptionContext.ts';
import { getPremiumSuffix } from '@/App/tiles/Option/utils/premiumUtils.ts';
import { useFormatPremium } from '@/App/tiles/Option/utils/useFormatPremium.ts';
import { selectOptionCurrency } from '@/store/option/selectors/optionSelectors.ts';
import type { PremiumType } from '@/store/option/state.ts';

interface FormattedPremiumProps {
  premiumAmount: number | undefined;
  premiumType: PremiumType;
  className?: string;
  suffixClassName?: string;
}

export function FormattedPremium({ premiumAmount, premiumType, className, suffixClassName }: FormattedPremiumProps) {
  const { currency1, currency2, currencyPair } = useOptionSelector(selectOptionCurrency);
  const formatPremium = useFormatPremium(currencyPair);

  const premiumCategory = premiumType.premiumCategory;
  const premiumTypeCurrencyIndex = premiumType.premiumCurrency;
  const premiumCurrency = premiumTypeCurrencyIndex === 2 ? currency2 : currency1;

  const formattedRate = formatPremium(premiumAmount, premiumCategory);
  const premiumSuffix = getPremiumSuffix(premiumCategory, premiumCurrency);

  return (
    <>
      <span className={clsx('monospace-numbers', className)}>{formattedRate}</span>
      <span className={suffixClassName}>{premiumSuffix}</span>
    </>
  );
}
